// ═══════════════════════════════════════════════════════════════════════════
// FILE: src/Screens/admin/Users/RentalOwnersManagement.jsx
// PURPOSE: Screen wrapper — holds owners state + equipment data
//          Passes data + handlers down to RentalOwnersList
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState , useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminMasterLayout from "../../../../layout/superadmin/MasterLayout";
import RentalOwnersList from "../../../../subscreens/superadmin/UserManagment/rentalownermanagment/rentalownerlist/RentalOwnerList";
import tractor1Img from '../../../../assets/images/home/tractor1.jpg';
import tractorImg from '../../../../assets/images/home/tractor.jpg';
import tractor2Img from '../../../../assets/images/home/tractor2.jpg';
import tractor7Img from '../../../../assets/images/home/tractor7.jpg';
import tractor4Img from '../../../../assets/images/home/tractor4.jpg'; 
import tractor5Img from '../../../../assets/images/home/tractor5.jpg';
import tractor6Img from '../../../../assets/images/home/tractor6.jpg';
import tractor8Img from '../../../../assets/images/home/tractor8.jpg';
import harvestorImg from '../../../../assets/images/home/harvestor.jpg';
import harvestor1Img from '../../../../assets/images/home/harvestor1.jpg';
import harvestor2Img from '../../../../assets/images/home/harvestor2.jpg';
import harvestor3Img from '../../../../assets/images/home/harvestor1.jpg';
import harvestor4Img from '../../../../assets/images/home/harvestor2.jpg';
import sprayerImg from '../../../../assets/images/home/sprayer2.jpg';

import sprayer2Img from '../../../../assets/images/home/sprayer2.jpg';
import sprayer3Img from '../../../../assets/images/home/sprayer1.jpg';
import '../../../../assets/css/superadmin/usersmangment/rentalownermangment/RentalOwnerManagment.css';
import AppContext from "../../../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";

const RentalOwner = () => {
   const { baseUrl, authToken } = useContext(AppContext);

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [owners, setOwners] = useState([]);

  // ── Equipment Data  (5–6 realistic items per owner) ────────────────────────
  const ownerEquipments = {};

    const viewAllRentals = () => {
    axios
      .get(`${baseUrl}/superadmin/rental/viewAllRentals`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success == true) {
          setOwners(response.data.rentals);
        } else {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load Rentals",
        });
      });
  };

   const handleToggleStatus = (rentalId) => {
    const formData = new FormData();
    formData.append("id", rentalId);
    axios
      .post(`${baseUrl}/superadmin/rental/rentalStatus`, formData, {
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Rental status updated successfully",
          });
          viewAllRentals();
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update status",
        });
      });
  }; 

   useEffect(() => {
    viewAllRentals();
  }, []);

  // ── Handlers ───────────────────────────────────────────────────────────────
  const handleViewDetails = (owner) => {
    // Reserved for future detail page navigation
    console.log('View details:', owner);
  };

  const handleBlockOwner = (id) => {
    setOwners(prev =>
      prev.map(o => o.id === id ? { ...o, isBlocked: !o.isBlocked } : o)
    );
  };

  const handleViewEquipments = (owner) => {
    navigate('/superadmin/users/rental-owners/equipments', {
      state: {
        owner,
        equipments: ownerEquipments[owner.id] || [],
      },
    });
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <AdminMasterLayout>
      <div className="rental-owners-container">
        <RentalOwnersList
          owners={owners}
          onViewDetails={handleViewDetails}
          onBlock={handleBlockOwner}
          onViewEquipments={handleViewEquipments}
        />
      </div>
    </AdminMasterLayout>
  );
};

export default RentalOwner; 